import React, { useState } from 'react';

const ProfilePage = ({ username, triggerToast, robloxusername, clickCount, robuxBalance, realuserID, fetchUserData, refs }) => {
  const [robloxUsername, setRobloxUsername] = useState('');
  const [verificationCode] = useState('CLICKER123');
  const [clicksToConvert, setClicksToConvert] = useState("");
  const [isVerified, setIsVerified] = useState(!!robloxusername); // Устанавливаем true, если robloxusername передан
  const robuxEquivalent = Math.floor(clicksToConvert / 5000) || 0;

  const handleclck = async () => {
    triggerToast("Приём заявок на вывод будет открыт при 10.000 игроков.");
  };

  const handleVerify = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/roblox/verify`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ robloxUsername, verificationCode, realuserID }),
      });

      if (response.ok) {
        setIsVerified(true);
        triggerToast('Ваш аккаунт успешно подтверждён!');
      } else {
        triggerToast('Не удалось подтвердить аккаунт. Проверьте описание вашего профиля.');
      }
    } catch (error) {
      console.error('Ошибка:', error);
    }
  };

  const handleExchange = async () => {
    // Проверка на количество рефералов
    if (refs < 20) {
      triggerToast("Необходимо пригласить хотя бы 20 игроков для обмена!");
      return;
    }

    try {
      // Валидация введённого значения
      if (!clicksToConvert || clicksToConvert <= 0) {
        triggerToast("Введите корректное количество кликов для обмена!");
        return;
      }

      if (clicksToConvert > clickCount) {
        triggerToast("Недостаточно кликов для обмена!");
        return;
      }

      // Отправка запроса на сервер для обмена
      const userId = realuserID;
      const response = await fetch(`${process.env.REACT_APP_API_URL}/roblox/exchange`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ clicks: clicksToConvert, userId }),
      });

      if (response.ok) {
        triggerToast("Обмен успешно выполнен!");
        setClicksToConvert(""); // Сброс поля ввода
        fetchUserData(username);
      } else {
        triggerToast("Ошибка при выполнении обмена!");
      }
    } catch (error) {
      console.error("Ошибка обмена:", error);
      triggerToast("Ошибка сервера при выполнении обмена!");
    }
  };

  return (
    <div className="container_">
      {!isVerified ? (
        <div className="verification-section">
          <h1 className="profile-titles">Верификация аккаунта Roblox</h1>
          <p className="profile-instructions">
            Введите своё имя в Roblox и добавьте этот код в описание профиля:
            <strong className="verification-code">{verificationCode}</strong>
          </p>
          <input
            className="profile-inputs"
            type="text"
            value={robloxUsername}
            onChange={(e) => setRobloxUsername(e.target.value)}
            placeholder="Ваш Roblox username"
          />
          <button className="profile-buttons" onClick={handleVerify}>
            Подтвердить аккаунт
          </button>
        </div>
      ) : (
        <div>
          {/* Блок с балансом */}
          <div className="balance-item">
            <img
              src="/assets/imgur/rp2IzCs.png" // Замените на путь к вашей картинке для робуксов
              alt="Робуксы"
              className="balance-icon"
            />
            <span className="balance-value">{robuxBalance.toLocaleString()}</span>
          </div>
          <div className="balance-item">
            <img
              src="/assets/currency-coin-v2.png"
              alt="Клики"
              className="balance-icon"
            />
            <span className="balance-value">{clickCount.toLocaleString()}</span>
          </div>

          <input
            type="number"
            className="profile-inputs"
            placeholder="Введите количество кликов"
            value={clicksToConvert}
            onChange={(e) => setClicksToConvert(Number(e.target.value))}
          />
          <div className="exchange-rate">
            {clicksToConvert > 0
              ? `${clicksToConvert.toLocaleString()} кликов = ${robuxEquivalent.toLocaleString()} робуксов`
              : "5000 кликов = 1 робукс"}
          </div>
          <button className="exchange-button" onClick={handleExchange}>
            Подтвердить
          </button>
          <h1>Или выведи робуксы по кнопке ниже!</h1>
          <button className="exchange-button" onClick={handleclck}>
            Вывести всё!
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfilePage;
